import { render, staticRenderFns } from "./MeterRelations.yaml?vue&type=template&id=525e60e5&component"
import script from "./MeterRelations.yaml?vue&type=script&lang=ts&component"
export * from "./MeterRelations.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports